import { createFileRoute } from '@tanstack/react-router';

import { LikesPages } from '@/features/likes/components/likesPage';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute('/_protected/_app/_mainLayout/likes/')({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: 'Likes' }],
  }),
});

function RouteComponent() {
  return (
    <MainLayout.Root className="pb-navbar h-full">
      <PageHeader.Root>
        <PageHeader.Title>Likes & Reveals</PageHeader.Title>
        <PageHeader.NonToxicBadge />
      </PageHeader.Root>
      <LikesPages />
    </MainLayout.Root>
  );
}
